<template>
  <head>
    <title>{{ $t("websiteInfo") }}</title>
  </head>
  <div class="admin-home">
    <AdminSidebar>
      <form class="form bg-dark my-5" @submit.prevent="SubmitCheck()">
        <p class="title">{{ $t("websiteInfo") }}</p>

        <div class="flex">
          <label class="w-49">
            <input
              placeholder=""
              type="text"
              class="input"
              name="welcome_message_ar"
              v-model="data.welcome_message_ar"
            />
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
              }"
              >{{ $t("welcomeMessageAr") }}</span
            >
          </label>
          <label class="w-49">
            <input
              placeholder=""
              type="text"
              class="input"
              name="welcome_message_en"
              v-model="data.welcome_message_en"
            />
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
              }"
              >{{ $t("welcomeMessageEn") }}</span
            >
          </label>
        </div>

        <div class="flex">
          <label class="w-49">
            <input
              placeholder=""
              type="text"
              class="input"
              name="our_partners_ar"
              v-model="data.our_partners_ar"
            />
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
              }"
              >{{ $t("our_partners_ar") }}</span
            >
          </label>
          <label class="w-49">
            <input
              placeholder=""
              type="text"
              class="input"
              name="our_partners_en"
              v-model="data.our_partners_en"
            />
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
              }"
              >{{ $t("our_partners_en") }}</span
            >
          </label>
        </div>

        <div class="flex">
          <label class="w-49">
            <textarea
              placeholder=""
              class="input"
              name="about_us_ar"
              v-model="data.about_us_ar"
            ></textarea>
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
                top: '50px',
              }"
              >{{ $t("aboutUsAr") }}</span
            >
          </label>
          <label class="w-49">
            <textarea
              placeholder=""
              class="input"
              name="about_us_en"
              v-model="data.about_us_en"
            ></textarea>
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
                top: '50px',
              }"
              >{{ $t("aboutUsEn") }}</span
            >
          </label>
        </div>

        <div class="flex">
          <label class="w-49">
            <textarea
              placeholder=""
              class="input"
              name="our_vision_message_ar"
              v-model="data.our_vision_message_ar"
            ></textarea>
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
                top: '50px',
              }"
              >{{ $t("our_vision_message_ar") }}</span
            >
          </label>
          <label class="w-49">
            <textarea
              placeholder=""
              class="input"
              name="our_vision_message_en"
              v-model="data.our_vision_message_en"
            ></textarea>
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
                top: '50px',
              }"
              >{{ $t("our_vision_message_en") }}</span
            >
          </label>
        </div>

        <label>
          <input
            placeholder=""
            type="text"
            class="input"
            name="map_link"
            v-model="data.map_link"
          />
          <span
            :style="{
              left: $i18n.locale == 'ar' ? '' : '10px',
              right: $i18n.locale == 'ar' ? '10px' : '',
            }"
            >{{ $t("map_link") }}</span
          >
        </label>

        <label>
          <input
            placeholder=""
            type="email"
            class="input"
            name="email"
            v-model="data.email"
          />
          <span
            :style="{
              left: $i18n.locale == 'ar' ? '' : '10px',
              right: $i18n.locale == 'ar' ? '10px' : '',
            }"
            >{{ $t("email") }}</span
          >
        </label>

        <label>
          <input
            placeholder=""
            type="text"
            class="input"
            name="phone"
            v-model="data.phone"
          />
          <span
            :style="{
              left: $i18n.locale == 'ar' ? '' : '10px',
              right: $i18n.locale == 'ar' ? '10px' : '',
            }"
            >{{ $t("phone") }}</span
          >
        </label>

        <div class="flex">
          <label class="w-49">
            <input
              placeholder=""
              type="text"
              class="input"
              name="loaction_name_ar"
              v-model="data.loaction_name_ar"
            />
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
              }"
              >{{ $t("location_name_ar") }}</span
            >
          </label>
          <label class="w-49">
            <input
              placeholder=""
              type="text"
              class="input"
              name="location_name_en"
              v-model="data.location_name_en"
            />
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
              }"
              >{{ $t("location_name_en") }}</span
            >
          </label>
        </div>

        <label>
          <input
            placeholder=""
            type="text"
            class="input"
            name="twitter"
            v-model="social_media.twitter"
            min="0"
          />
          <span
            :style="{
              left: $i18n.locale == 'ar' ? '' : '10px',
              right: $i18n.locale == 'ar' ? '10px' : '',
            }"
            >{{ $t("twitter") }}</span
          >
        </label>

        <label>
          <input
            placeholder=""
            type="text"
            class="input"
            name="instagram"
            v-model="social_media.instagram"
            min="0"
          />
          <span
            :style="{
              left: $i18n.locale == 'ar' ? '' : '10px',
              right: $i18n.locale == 'ar' ? '10px' : '',
            }"
            >{{ $t("instagram") }}</span
          >
        </label>

        <label>
          <input
            placeholder=""
            type="text"
            class="input"
            name="skype"
            v-model="social_media.skype"
            min="0"
          />
          <span
            :style="{
              left: $i18n.locale == 'ar' ? '' : '10px',
              right: $i18n.locale == 'ar' ? '10px' : '',
            }"
            >{{ $t("skype") }}</span
          >
        </label>

        <label>
          <input
            placeholder=""
            type="text"
            class="input"
            name="linkdin"
            v-model="social_media.linkdin"
            min="0"
          />
          <span
            :style="{
              left: $i18n.locale == 'ar' ? '' : '10px',
              right: $i18n.locale == 'ar' ? '10px' : '',
            }"
            >{{ $t("linkdin") }}</span
          >
        </label>

        <label>
          <input
            placeholder=""
            type="text"
            class="input"
            name="facebook"
            v-model="social_media.facebook"
            min="0"
          />
          <span
            :style="{
              left: $i18n.locale == 'ar' ? '' : '10px',
              right: $i18n.locale == 'ar' ? '10px' : '',
            }"
            >{{ $t("facebook") }}</span
          >
        </label>

        <div
          class="flex justify-content-center align-items-center"
          style="gap: 30px"
        >
          <!-- welcome image -->
          <label class="custum-file-upload" for="welcome">
            <div class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill=""
                viewBox="0 0 24 24"
              >
                <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                <g
                  stroke-linejoin="round"
                  stroke-linecap="round"
                  id="SVGRepo_tracerCarrier"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    fill=""
                    d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                    clip-rule="evenodd"
                    fill-rule="evenodd"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="text">
              <span>{{
                files.welcome ? $t("uploaded") : $t("uploadWelcome")
              }}</span>
            </div>
            <input
              type="file"
              id="welcome"
              accept="image/*"
              @change="handleFileUpload($event, 'welcome')"
            />
          </label>

          <!-- uploadAbout -->
          <label class="custum-file-upload" for="about_ar">
            <div class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill=""
                viewBox="0 0 24 24"
              >
                <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                <g
                  stroke-linejoin="round"
                  stroke-linecap="round"
                  id="SVGRepo_tracerCarrier"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    fill=""
                    d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                    clip-rule="evenodd"
                    fill-rule="evenodd"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="text">
              <span>{{
                files.about_ar
                  ? $t("uploaded")
                  : $t("uploadAbout") + " " + $t("ar")
              }}</span>
            </div>
            <input
              type="file"
              id="about_ar"
              accept="image/*"
              @change="handleFileUpload($event, 'about_ar')"
            />
          </label>

          <label class="custum-file-upload" for="about_en">
            <div class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill=""
                viewBox="0 0 24 24"
              >
                <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                <g
                  stroke-linejoin="round"
                  stroke-linecap="round"
                  id="SVGRepo_tracerCarrier"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    fill=""
                    d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                    clip-rule="evenodd"
                    fill-rule="evenodd"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="text">
              <span>{{
                files.about_en
                  ? $t("uploaded")
                  : $t("uploadAbout") + " " + $t("en")
              }}</span>
            </div>
            <input
              type="file"
              id="about_en"
              accept="image/*"
              @change="handleFileUpload($event, 'about_en')"
            />
          </label>

          <!-- uploadVision -->
          <label class="custum-file-upload" for="vision_ar">
            <div class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill=""
                viewBox="0 0 24 24"
              >
                <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                <g
                  stroke-linejoin="round"
                  stroke-linecap="round"
                  id="SVGRepo_tracerCarrier"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    fill=""
                    d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                    clip-rule="evenodd"
                    fill-rule="evenodd"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="text">
              <span>{{
                files.vision_ar
                  ? $t("uploaded")
                  : $t("uploadVision") + " " + $t("ar")
              }}</span>
            </div>
            <input
              type="file"
              id="vision_ar"
              accept="image/*"
              @change="handleFileUpload($event, 'vision_ar')"
            />
          </label>

          <label class="custum-file-upload" for="vision_en">
            <div class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill=""
                viewBox="0 0 24 24"
              >
                <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                <g
                  stroke-linejoin="round"
                  stroke-linecap="round"
                  id="SVGRepo_tracerCarrier"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    fill=""
                    d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                    clip-rule="evenodd"
                    fill-rule="evenodd"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="text">
              <span>{{
                files.vision_en
                  ? $t("uploaded")
                  : $t("uploadVision") + " " + $t("en")
              }}</span>
            </div>
            <input
              type="file"
              id="vision_en"
              accept="image/*"
              @change="handleFileUpload($event, 'vision_en')"
            />
          </label>

          <!-- uploadPartners -->
          <label class="custum-file-upload" for="OurPartners_ar">
            <div class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill=""
                viewBox="0 0 24 24"
              >
                <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                <g
                  stroke-linejoin="round"
                  stroke-linecap="round"
                  id="SVGRepo_tracerCarrier"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    fill=""
                    d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                    clip-rule="evenodd"
                    fill-rule="evenodd"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="text">
              <span>{{
                files.partners_ar
                  ? $t("uploaded")
                  : $t("Partners") + " " + $t("ar")
              }}</span>
            </div>
            <input
              type="file"
              id="OurPartners_ar"
              accept="image/*"
              @change="handleFileUpload($event, 'partners_ar')"
            />
          </label>

          <label class="custum-file-upload" for="OurPartners_en">
            <div class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill=""
                viewBox="0 0 24 24"
              >
                <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                <g
                  stroke-linejoin="round"
                  stroke-linecap="round"
                  id="SVGRepo_tracerCarrier"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    fill=""
                    d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                    clip-rule="evenodd"
                    fill-rule="evenodd"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="text">
              <span>{{
                files.partners_en
                  ? $t("uploaded")
                  : $t("Partners") + " " + $t("en")
              }}</span>
            </div>
            <input
              type="file"
              id="OurPartners_en"
              accept="image/*"
              @change="handleFileUpload($event, 'partners_en')"
            />
          </label>

          <!-- uploadWhy -->
          <label class="custum-file-upload" for="WhyNexus_ar">
            <div class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill=""
                viewBox="0 0 24 24"
              >
                <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                <g
                  stroke-linejoin="round"
                  stroke-linecap="round"
                  id="SVGRepo_tracerCarrier"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    fill=""
                    d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                    clip-rule="evenodd"
                    fill-rule="evenodd"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="text">
              <span>{{
                files.why_ar ? $t("uploaded") : $t("why") + " " + $t("ar")
              }}</span>
            </div>
            <input
              type="file"
              id="WhyNexus_ar"
              accept="image/*"
              @change="handleFileUpload($event, 'why_ar')"
            />
          </label>

          <label class="custum-file-upload" for="WhyNexus_en">
            <div class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill=""
                viewBox="0 0 24 24"
              >
                <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                <g
                  stroke-linejoin="round"
                  stroke-linecap="round"
                  id="SVGRepo_tracerCarrier"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    fill=""
                    d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                    clip-rule="evenodd"
                    fill-rule="evenodd"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="text">
              <span>{{
                files.why_en ? $t("uploaded") : $t("why") + " " + $t("en")
              }}</span>
            </div>
            <input
              type="file"
              id="WhyNexus_en"
              accept="image/*"
              @change="handleFileUpload($event, 'why_en')"
            />
          </label>

          <!-- uploadVideo -->
          <label class="custum-file-upload" for="video">
            <div class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill=""
                viewBox="0 0 24 24"
              >
                <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                <g
                  stroke-linejoin="round"
                  stroke-linecap="round"
                  id="SVGRepo_tracerCarrier"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    fill=""
                    d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                    clip-rule="evenodd"
                    fill-rule="evenodd"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="text">
              <span>{{
                files.video ? $t("uploaded") : $t("uploadVideo")
              }}</span>
            </div>
            <input
              type="file"
              id="video"
              accept="video/*"
              @change="handleFileUpload($event, 'video')"
            />
          </label>
        </div>

        <div
          class="Error"
          :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
          style="text-align: start"
          v-if="ErrorMessage"
        >
          {{ ErrorMessage }}
        </div>
        <button class="submit">
          {{ isEmpty == 0 ? $t("add") : $t("update") }}
        </button>
      </form>
    </AdminSidebar>
  </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
import AdminSidebar from "@/components/AdminDashboard/AdminSidebar.vue";

export default {
  name: "admin-home",
  data() {
    return {
      data: {
        id: "",
        socialmedia_id: "",
        welcome_message_ar: "",
        welcome_message_en: "",
        about_us_ar: "",
        about_us_en: "",
        our_vision_message_en: "",
        our_vision_message_ar: "",
        map_link: "",
        email: "",
        phone: "",
        location_name_en: "",
        loaction_name_ar: "",
        our_partners_en: "",
        our_partners_ar: "",
      },
      social_media: {},
      isEmpty: 0,
      ErrorMessage: "",
      IgnoreKeys: [
        "id",
        "twitter",
        "facebook",
        "linkdin",
        "instagram",
        "skype",
        "map_link",
        "loaction_name_ar",
        "location_name_en",
        "clients",
        "created_at",
        "products",
        "services",
        "social_media",
        "team",
        "socialmedia_id",
        "updated_at",
        "video",
      ],
      files: {
        welcome: null,
        about_ar: null,
        about_en: null,
        vision_ar: null,
        vision_en: null,
        partners_ar: null,
        partners_en: null,
        why_ar: null,
        why_en: null,
        video: null,
      },
    };
  },
  methods: {
    handleFileUpload(e, key) {
      this.files[key] = e.target.files[0];
    },
    getData() {
      store.state.loading_state = 1;
      axios
        .get(store.state.server + "api/get_website_id/1")
        .then((response) => {
          const data = response.data.data;
          if (data !== null) {
            this.isEmpty = 1;
            this.social_media = response.data.data.social_media;
            for (let key in this.data) {
              this.data[key] = data[key];
            }
            store.state.unread = response.data.unread;
            store.state.loading_state = 0;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SubmitCheck() {
      this.ErrorMessage = "";
      if (this.isEmpty) {
        this.updateWebsite();
      } else {
        this.addWebsite();
      }
    },
    addWebsite() {
      store.state.loading_state = 1;
      this.data["facebook"] =
        this.social_media.facebook == undefined
          ? ""
          : this.social_media.facebook;
      this.data["instagram"] =
        this.social_media.instagram == undefined
          ? ""
          : this.social_media.instagram;
      this.data["linkdin"] =
        this.social_media.linkdin == undefined ? "" : this.social_media.linkdin;
      this.data["skype"] =
        this.social_media.skype == undefined ? "" : this.social_media.skype;
      this.data["twitter"] =
        this.social_media.twitter == undefined ? "" : this.social_media.twitter;
      this.data["map_link"] =
        this.data.map_link == undefined ? "" : this.data.map_link;

      for (let key in this.data) {
        if (this.IgnoreKeys.includes(key)) {
          continue;
        } else if (this.data[key] == "" || this.data[key] == undefined) {
          console.log(key);
          this.ErrorMessage =
            this.$i18n.locale === "ar"
              ? "الرجاء تعبئة كل الحقول المطلوبة"
              : "Please fill all the required fields";
          store.state.loading_state = 0;
          return;
        }
      }

      const form = new FormData();

      const welcome = document.querySelector("#welcome");
      const welcomeFiles = welcome.files;
      const vision_ar = document.querySelector("#vision_ar");
      const vision_ar_Files = vision_ar.files;
      const about_ar = document.querySelector("#about_ar");
      const about_ar_Files = about_ar.files;
      const vision_en = document.querySelector("#vision_en");
      const vision_en_Files = vision_en.files;
      const about_en = document.querySelector("#about_en");
      const about_en_Files = about_en.files;
      const OurPartners_ar = document.querySelector("#OurPartners_ar");
      const OurPartners_ar_Files = OurPartners_ar.files;
      const OurPartners_en = document.querySelector("#OurPartners_en");
      const OurPartners_en_Files = OurPartners_en.files;

      const WhyNexus_ar = document.querySelector("#WhyNexus_ar");
      const WhyNexus_ar_Files = WhyNexus_ar.files;
      const WhyNexus_en = document.querySelector("#WhyNexus_en");
      const WhyNexus_en_Files = WhyNexus_en.files;

      const video = document.querySelector("#video");
      const videoFiles = video.files;

      if (welcomeFiles.length > 0) {
        form.append(`welcome_img`, welcomeFiles[0]);
      } else {
        this.ErrorMessage =
          this.$i18n.locale === "ar"
            ? "الرجاء رفع صورة الترحيب"
            : "Please upload welcome home image";
        store.state.loading_state = 0;
        return;
      }

      if (vision_ar_Files.length > 0) {
        form.append(`our_vision_img_ar`, vision_ar_Files[0]);
      } else {
        this.ErrorMessage =
          this.$i18n.locale === "ar"
            ? "الرجاء رفع صورة الرؤية"
            : "Please upload Vision image";
        store.state.loading_state = 0;
        return;
      }

      if (vision_en_Files.length > 0) {
        form.append(`our_vision_img_en`, vision_en_Files[0]);
      } else {
        this.ErrorMessage =
          this.$i18n.locale === "ar"
            ? "الرجاء رفع صورة الرؤية"
            : "Please upload Vision image";
        store.state.loading_state = 0;
        return;
      }

      if (about_ar_Files.length > 0) {
        form.append(`about_us_img_ar`, about_ar_Files[0]);
      } else {
        this.ErrorMessage =
          this.$i18n.locale === "ar"
            ? "الرجاء رفع صورة من نحن"
            : "Please upload about us image";
        store.state.loading_state = 0;
        return;
      }

      if (about_en_Files.length > 0) {
        form.append(`about_us_img_en`, about_en_Files[0]);
      } else {
        this.ErrorMessage =
          this.$i18n.locale === "ar"
            ? "الرجاء رفع صورة من نحن"
            : "Please upload about us image";
        store.state.loading_state = 0;
        return;
      }

      if (OurPartners_ar_Files.length > 0) {
        form.append(`our_partners_img_ar`, OurPartners_ar_Files[0]);
      } else {
        this.ErrorMessage =
          this.$i18n.locale === "ar"
            ? "الرجاء رفع صورة قسم شركائنا"
            : "Please upload our partneres section image";
        store.state.loading_state = 0;
        return;
      }

      if (OurPartners_en_Files.length > 0) {
        form.append(`our_partners_img_en`, OurPartners_en_Files[0]);
      } else {
        this.ErrorMessage =
          this.$i18n.locale === "ar"
            ? "الرجاء رفع صورة قسم شركائنا"
            : "Please upload our partneres section image";
        store.state.loading_state = 0;
        return;
      }

      if (WhyNexus_ar_Files.length > 0) {
        form.append(`why_nexus_img_ar`, WhyNexus_ar_Files[0]);
      } else {
        this.ErrorMessage =
          this.$i18n.locale === "ar"
            ? "الرجاء رفع صورة قسم لماذا نكسس ليب"
            : "Please upload Why nexus leap section image";
        store.state.loading_state = 0;
        return;
      }

      if (WhyNexus_en_Files.length > 0) {
        form.append(`why_nexus_img_en`, WhyNexus_en_Files[0]);
      } else {
        this.ErrorMessage =
          this.$i18n.locale === "ar"
            ? "الرجاء رفع صورة قسم لماذا نكسس ليب"
            : "Please upload Why nexus leap section image";
        store.state.loading_state = 0;
        return;
      }

      if (videoFiles.length > 0) {
        form.append(`video`, videoFiles[0]);
      }

      for (const [key, value] of Object.entries(this.data)) {
        form.append(key, value);
      }

      const token = window.sessionStorage.getItem("token");
      axios
        .post(store.state.server + "api/create_website", form, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.status == 200) {
            store.state.loading_state = 0;
            location.reload();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateWebsite() {
      store.state.loading_state = 1;
      this.data["facebook"] =
        this.social_media.facebook == undefined
          ? ""
          : this.social_media.facebook;
      this.data["instagram"] =
        this.social_media.instagram == undefined
          ? ""
          : this.social_media.instagram;
      this.data["linkdin"] =
        this.social_media.linkdin == undefined ? "" : this.social_media.linkdin;
      this.data["skype"] =
        this.social_media.skype == undefined ? "" : this.social_media.skype;
      this.data["twitter"] =
        this.social_media.twitter == undefined ? "" : this.social_media.twitter;
      this.data["map_link"] =
        this.data.map_link == undefined ? "" : this.data.map_link;

      for (let key in this.data) {
        if (this.IgnoreKeys.includes(key)) {
          continue;
        } else if (this.data[key] == "" || this.data[key] == undefined) {
          console.log(key);
          this.ErrorMessage =
            this.$i18n.locale === "ar"
              ? "الرجاء تعبئة كل الحقول المطلوبة"
              : "Please fill all the required fields";
          store.state.loading_state = 0;
          return;
        }
      }

      const form = new FormData();

      const welcome = document.querySelector("#welcome");
      const welcomeFiles = welcome.files;
      const vision_ar = document.querySelector("#vision_ar");
      const vision_ar_Files = vision_ar.files;
      const about_ar = document.querySelector("#about_ar");
      const about_ar_Files = about_ar.files;
      const vision_en = document.querySelector("#vision_en");
      const vision_en_Files = vision_en.files;
      const about_en = document.querySelector("#about_en");
      const about_en_Files = about_en.files;
      const video = document.querySelector("#video");
      const videoFiles = video.files;
      const OurPartners_ar = document.querySelector("#OurPartners_ar");
      const OurPartners_ar_Files = OurPartners_ar.files;
      const OurPartners_en = document.querySelector("#OurPartners_en");

      const WhyNexus_ar = document.querySelector("#WhyNexus_ar");
      const WhyNexus_ar_Files = WhyNexus_ar.files;
      const WhyNexus_en = document.querySelector("#WhyNexus_en");
      const WhyNexus_en_Files = WhyNexus_en.files;

      const OurPartners_en_Files = OurPartners_en.files;

      if (welcomeFiles.length > 0) {
        form.append(`welcome_img`, welcomeFiles[0]);
      }

      if (vision_ar_Files.length > 0) {
        form.append(`our_vision_img_ar`, vision_ar_Files[0]);
      }

      if (vision_en_Files.length > 0) {
        form.append(`our_vision_img_en`, vision_en_Files[0]);
      }

      if (about_ar_Files.length > 0) {
        form.append(`about_us_img_ar`, about_ar_Files[0]);
      }

      if (about_en_Files.length > 0) {
        form.append(`about_us_img_en`, about_en_Files[0]);
      }

      if (videoFiles.length > 0) {
        form.append(`video`, videoFiles[0]);
      }

      if (OurPartners_ar_Files.length > 0) {
        form.append(`our_partners_img_ar`, OurPartners_ar_Files[0]);
      }

      if (OurPartners_en_Files.length > 0) {
        form.append(`our_partners_img_en`, OurPartners_en_Files[0]);
      }

      if (WhyNexus_ar_Files.length > 0) {
        form.append(`why_nexus_img_ar`, WhyNexus_ar_Files[0]);
      }

      if (WhyNexus_en_Files.length > 0) {
        form.append(`why_nexus_img_en`, WhyNexus_en_Files[0]);
      }

      for (const [key, value] of Object.entries(this.data)) {
        form.append(key, value);
      }

      const token = window.sessionStorage.getItem("token");
      axios
        .post(
          store.state.server + "api/update_website/" + this.data["id"],
          form,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          if (response.status == 200) {
            store.state.loading_state = 0;
            location.reload();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getData();
  },
  components: {
    AdminSidebar,
  },
};
</script>
